import { render, staticRenderFns } from "./CognitoEmailVerification.vue?vue&type=template&id=faaec188&scoped=true"
import script from "./CognitoEmailVerification.vue?vue&type=script&lang=js"
export * from "./CognitoEmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaec188",
  null
  
)

export default component.exports